import { DropdownOption } from "src/models";

export type ContactUsState = {
    loading: boolean;
    succeed: boolean;
    types: DropdownOption[];
    typesLoaded: boolean;
};

export const ContactUsInitialState: ContactUsState = {
    loading: false,
    succeed: false,
    types: [],
    typesLoaded: false
};